import { useEffect } from 'react';
import { getCrmChatSockJsUrl } from '@/config/chat-ws';
import { buildBreakUserTopic, parseBreakEvent } from '@/shared/model/break-event.model';
import { acquireCrmStompSharedConnection, onCrmStompSharedConnect, releaseCrmStompSharedConnection, subscribeCrmStompSharedTopic, } from '@/shared/ws/crmStompSharedClient';
/**
 * Subscribes to `/topic/break.user.{username}` on the shared CRM STOMP connection.
 */
export function useBreakUserTopicSubscription({ username, enabled = true, sockJsUrl = getCrmChatSockJsUrl(), onBreakEnded, }) {
    useEffect(() => {
        const trimmed = username?.trim() ?? '';
        if (!enabled || !trimmed)
            return undefined;
        let topic;
        try {
            topic = buildBreakUserTopic(trimmed);
        }
        catch {
            return undefined;
        }
        acquireCrmStompSharedConnection(sockJsUrl);
        const unsubscribeTopic = subscribeCrmStompSharedTopic(topic, (frame) => {
            const event = parseBreakEvent(frame.body);
            if (!event || event.eventType !== 'ENDED')
                return;
            onBreakEnded?.(event);
        });
        const detachConnect = onCrmStompSharedConnect(() => {
            /* topic re-subscribed automatically on shared reconnect */
        });
        return () => {
            detachConnect();
            unsubscribeTopic();
            releaseCrmStompSharedConnection();
        };
    }, [enabled, onBreakEnded, sockJsUrl, username]);
}
